import { useApiService } from "medere-ui-framework";
import { HonorariumDTO } from "../../dto/HonorariumDTO";

export function useHonorariumService() {
  const { api, postMethod } = useApiService();
  const baseEndpoint = "/api/secured/honorarium";

  function getHonorariums(offset: number, pageSize: number, params: any): Promise<HonorariumDTO[]> {
    const referenceDate = params.referenceDate
      ? new Date(params.referenceDate)
        .toISOString()
        .replace("Z", "")
        .split(".")[0]
      : undefined;

    return postMethod<HonorariumDTO[]>({
      basePath: baseEndpoint,
      endpoint: "/getHonorariums",
      body: {
        offSet: offset,
        pageSize,
        filters: { filters: [] },
        sortingFieldInfoList: []
      },
      params: {
        nomenclatorType: params.nomenclatorType?.id,
        nomenclator: params.nomenclator?.nomenclator,
        active: params.active,
        referenceDate
      }
    });
  }

  function modifyCurrentHonorarium(honorarium: HonorariumDTO) {
    return api.post(`${baseEndpoint}/modifyCurrentHonorarium`, honorarium, {
      params: {}
    }).then((response) => {
      return response;
    }).catch((error) => {
      console.error(error);
    });
  }

  function updateHonorarium(honorarium: HonorariumDTO) {
    return api.post(`${baseEndpoint}/updateHonorarium`, honorarium, {
      params: {
        prevHonoararium: honorarium.honorarium,
      }
    }).then((response) => {
      return response;
    }).catch((error) => {
      console.error(error);
    });
  }

  function createHonorarium(honorarium: HonorariumDTO) {
    return api.post(`${baseEndpoint}/createHonorarium`, honorarium, {
      params: {}
    }).then((response) => {
      return response;
    }).catch((error) => {
      console.error(error);
    });
  }

  return {
    getHonorariums,
    modifyCurrentHonorarium,
    updateHonorarium,
    createHonorarium,
  };
}
